<div class="energy-card" [class]="theme">
  <div class="card-accent"></div>

  <div class="card-header">
    <div class="title-section">
      <div class="title">
        {{ title }}
      </div>

      <div class="scope">
        {{ scope }}
      </div>
    </div>

    <div class="comparison-section">
      <div
        class="comparison"
        [class.increase]="comparisonValue > 0"
        [class.decrease]="comparisonValue < 0"
        [class.neutral]="comparisonValue === 0"
      >
        {{ comparison }}
      </div>

      <div class="comparison-label">
        {{ comparisonLabel }}
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <div class="card-content">
    <div class="metric">
      <div class="metric-label">Energy used</div>

      <div class="metric-value">
        <span class="value">
          {{ energyValue | number: "1.0-2" }}
        </span>

        <span class="unit">
          {{ energyUnit }}
        </span>
      </div>
    </div>

    <div class="metric carbon">
      <div class="metric-label">Carbon Emission</div>

      <div class="metric-value">
        <span class="value">
          {{ carbonValue | number: "1.0-2" }}
        </span>

        <span class="unit">
          {{ carbonUnit }}
        </span>
      </div>
    </div>
  </div>
</div>
